module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_33.dot-60aa921cb7cfe48c20c61c2be6d97c30.svg";